import React from "react";
import { useNavigate } from "react-router-dom";
import FavouriteButton from "./FavouriteButton";

const StocktakeDashboard = () => {
  const navigate = useNavigate();
  const go = (route) => navigate(route);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">
      <FavouriteButton pageUrl={window.location.pathname} />
      <h1 className="text-4xl font-semibold text-gray-800 mb-8">Stock Take Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-5xl">
        <Tile step={1} title="Stock Take Entry" onClick={() => go("/StockTakeForm")} />
        <Tile step={2} title="Stock Take Comparison" onClick={() => go("/StockComparison")} />
        <Tile step={3} title="Transfer Data (Scans → Duplicate)" onClick={() => go("/StocktakeToDuplicate")} />
        <Tile step={4} title="Duplicate Warehouse" onClick={() => go("/DuplicateWarehouse")} />
        <Tile step={5} title="Publish Duplicate → Live" onClick={() => go("/PublishDuplicateToLive")} />
        <Tile step={6} title="Help" onClick={() => go("/StocktakeInstructions")} />
      </div>
    </div>
  );
};

// Reusable numbered tile
const Tile = ({ step, title, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="group bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition cursor-pointer transform hover:-translate-y-1 flex flex-col items-center justify-center text-center w-full h-48 border border-gray-200"
      role="button"
      aria-label={`${title}, step ${step}`}
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick?.()}
    >
      <div className="flex items-center justify-center w-20 h-20 rounded-full bg-gray-200 group-hover:bg-primary transition">
        <span className="text-3xl font-bold text-gray-800 group-hover:text-white select-none">
          {step}
        </span>
      </div>
      <p className="mt-4 text-lg font-semibold text-gray-800 group-hover:text-primary transition">
        {title}
      </p>
    </div>
  );
};

export default StocktakeDashboard;
